"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc filter
 * @name common.filter:indexTaux
 * @function
 *
 * @description
 * Formats an indexTaux (ie. index, marge, periodicity).
 *
 * @param {IndexTaux} The indexTaux to filter.
 *
 * @returns {string} Formatted indexTaux.
 */
ngModule.filter("indexTaux", function ($indexTauxFormat) {
  return function indexTauxFilter(indexTaux) {
    return $indexTauxFormat(indexTaux);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/index-taux/indexTaux-filter.js
// module id = 2728
// module chunks = 13